<!-- Need to determine if the page is on a Mobile screen or not. There are various changes for Mobile, Logged In and Logged Out user -->
<template>
  <!-- Fifth Panel -->
  <div class="make-the-deans-list-container">
    <HighlighterTitle
        :class="`section-title`"
        
        :highlighter-size="`h2`"
        :highlighter-color="`accent03`"
        v-html="isMobile
        ? $cleanRTE(liquid.mobile_title, { useTextLink: true })
        : $cleanRTE(liquid.desktop_title, { useTextLink: true })"
      />
      <div
        class="subtitle"
        v-html="isMobile
        ? $cleanRTE(liquid.mobile_subtitle, { useTextLink: true })
        : $cleanRTE(liquid.desktop_subtitle, { useTextLink: true })" />
      <div class="description-container">
        <div class="description-box">
          <img src="https://cdn.shopify.com/s/files/1/0607/1844/8811/files/pencil.png?v=1696617719" alt="pencil" />
          <div class="description-box-title">Honor Roll</div>
          <div class="description-box-subtitle">spend $1 - $249</div>
        </div>
        <div v-if="!isMobile" class="description-arrow">
          <svg class="icon icon__arrow icon__arrow--right" width="62" height="31" viewBox="0 0 62 31" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.92725 13.3196C1.82268 13.3196 0.927246 14.215 0.927246 15.3196C0.927246 16.4241 1.82268 17.3196 2.92725 17.3196L2.92725 13.3196ZM61.3556 16.7338C62.1366 15.9528 62.1366 14.6864 61.3556 13.9054L48.6277 1.17745C47.8466 0.3964 46.5803 0.396399 45.7992 1.17745C45.0182 1.9585 45.0182 3.22483 45.7992 4.00588L57.1129 15.3196L45.7992 26.6333C45.0182 27.4143 45.0182 28.6807 45.7992 29.4617C46.5803 30.2428 47.8466 30.2428 48.6277 29.4617L61.3556 16.7338ZM2.92725 17.3196L59.9414 17.3196L59.9414 13.3196L2.92725 13.3196L2.92725 17.3196Z" fill="#E60050"/>
          </svg>
        </div>
        <div class="description-box">
          <img src="https://cdn.shopify.com/s/files/1/0607/1844/8811/files/notebook.png?v=1696617719" alt="green notebook" />
          <div class="description-box-title">Straight A’s</div>
          <div class="description-box-subtitle">spend $250 - $549</div>
        </div>
        <div v-if="!isMobile" class="description-arrow">
          <svg class="icon icon__arrow icon__arrow--right" width="62" height="31" viewBox="0 0 62 31" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.92725 13.3196C1.82268 13.3196 0.927246 14.215 0.927246 15.3196C0.927246 16.4241 1.82268 17.3196 2.92725 17.3196L2.92725 13.3196ZM61.3556 16.7338C62.1366 15.9528 62.1366 14.6864 61.3556 13.9054L48.6277 1.17745C47.8466 0.3964 46.5803 0.396399 45.7992 1.17745C45.0182 1.9585 45.0182 3.22483 45.7992 4.00588L57.1129 15.3196L45.7992 26.6333C45.0182 27.4143 45.0182 28.6807 45.7992 29.4617C46.5803 30.2428 47.8466 30.2428 48.6277 29.4617L61.3556 16.7338ZM2.92725 17.3196L59.9414 17.3196L59.9414 13.3196L2.92725 13.3196L2.92725 17.3196Z" fill="#E60050"/>
          </svg>
        </div>
        <div class="description-box">
          <img src="https://cdn.shopify.com/s/files/1/0607/1844/8811/files/hundred.png?v=1696617720" alt="pink hundred" />
          <div class="description-box-title">Valedictorian</div>
          <div class="description-box-subtitle">spend $550 - $999</div>
        </div>
        <div v-if="!isMobile" class="description-arrow">
          <svg class="icon icon__arrow icon__arrow--right" width="62" height="31" viewBox="0 0 62 31" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.92725 13.3196C1.82268 13.3196 0.927246 14.215 0.927246 15.3196C0.927246 16.4241 1.82268 17.3196 2.92725 17.3196L2.92725 13.3196ZM61.3556 16.7338C62.1366 15.9528 62.1366 14.6864 61.3556 13.9054L48.6277 1.17745C47.8466 0.3964 46.5803 0.396399 45.7992 1.17745C45.0182 1.9585 45.0182 3.22483 45.7992 4.00588L57.1129 15.3196L45.7992 26.6333C45.0182 27.4143 45.0182 28.6807 45.7992 29.4617C46.5803 30.2428 47.8466 30.2428 48.6277 29.4617L61.3556 16.7338ZM2.92725 17.3196L59.9414 17.3196L59.9414 13.3196L2.92725 13.3196L2.92725 17.3196Z" fill="#E60050"/>
          </svg>
        </div>
        <div class="description-box">
          <img src="https://cdn.shopify.com/s/files/1/0607/1844/8811/files/ray.png?v=1696617719" alt="green ray" />
          <div class="description-box-title">SUPER SCHOLAR</div>
          <div class="description-box-subtitle">spend $1000+</div>
        </div>
      </div>
  </div>

  <!-- Sixth Panel (Mobile gets 4 panels here instead of one)-->
  <div class="perks-container">
    <template v-for="(image, index) in liquid.mobile_images" v-if="isMobile" :key="`${index}-mobile-image`">
      <img :src="image.src" :alt="image.alt" />
    </template>
    <img  v-if="!isMobile" :src="liquid.desktop_image.src" :alt="liquid.desktop_image.alt" />
    <span class="obs">{{ liquid.footnote }}</span>

  </div>

</template>

<script>

import { mapState, mapActions } from 'vuex'
import HighlighterTitle from '~global/highlighter-title/highlighter-title'
import Btn from '~global/btn/btn'

export default {
  name: 'LoyaltyLion',
  components: {
    HighlighterTitle,
    Btn
  },

  props: {
    liquid: {
      type: Object,
      default: () => ({
        desktop_image: {},
        footnote: '',
        mobile_images: [],
        desktop_title: '',
        desktop_subtitle: '',
        mobile_title: '',
        mobile_subtitle: '',
      }),
    }
  },

  data() {
    return {
    }
  },

  computed: {

    /**
     * Map Vuex state.
    */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),

  },

  mounted() {

    this.setComponentState({ handle: 'loyalty-lion-perks', state: 'active' })

  },

  methods: {

    /**
     * Map Vuex actions.
    */
    ...mapActions({
      setComponentState: 'components/setState',
    }),

  },
}
</script>

<style lang="scss">
@import './loyalty-lion-perks';
</style>
